import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReplaceKeywordsPipe } from './replace-keywords.pipe';


@NgModule({
    declarations: [ReplaceKeywordsPipe],
    exports: [ReplaceKeywordsPipe],
    imports: [
      CommonModule
    ],
    providers: [
      ReplaceKeywordsPipe
    ]
  })
export class ReplaceKeywordsPipeModule { }
